module.exports = __webpack_public_path__ + "static/media/106.77442d65.png";